export default __webpack_public_path__ + "/dist/images/blog-icon.svg";